import { useCallback, useEffect, useRef, useState } from "react";
import { useRecoilValue } from "recoil";

import Account from "./SettingsContent/Account/Account";
import Preferences from "./SettingsContent/Preferences/Preferences";
import DeletePopup from "./DeletePopup";

import { accountState } from "../../recoil/account/accountStateV2";
import { Flex, useMediaQuery } from "@chakra-ui/react";
import SettingsContent from "./SettingsContent/SettingsContent";
import SettingsSidebar from "./SettingsSidebar/SettingsSidebar";

const useTabs = (initialTab, allTabs) => {
  const [currentIndex, setCurrentIndex] = useState(initialTab);

  return {
    currentIndex: currentIndex,
    currentItem: allTabs[currentIndex],
    changeItem: setCurrentIndex,
  };
};

export default function Settings({ settingState, onClose }) {
  const settingsRef = useRef(null);
  const accountData = useRecoilValue(accountState);
  const [isSmallScreen] = useMediaQuery("(max-width: 640px)");

  const [isDeletePopup, setIsDeletePopup] = useState(false);
  // TODO 유저 정보 useQuery로 분리해서 해당 hook 사용하도록 수정
  const [loginData, setLoginData] = useState({
    emails: [],
    familyName: "",
    givenName: "",
    photoUrl: "",
    invitees: [],
    role: "",
    invitedBy: "",
  });

  const loadLoginData = () => {
    const invitees = accountData?.invitees ?? [];
    const combinedAccounts = [accountData.email];

    setLoginData({
      emails: combinedAccounts,
      familyName: accountData.familyName ?? "",
      givenName: accountData.givenName ?? "",
      photoUrl: accountData.photoUrl,
      invitees: invitees,
      role: accountData.membership,
    });
  };

  useEffect(() => {
    const escKeyModalClose = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", escKeyModalClose);
    return () => window.removeEventListener("keydown", escKeyModalClose);
  }, [onClose]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (settingsRef.current && !settingsRef.current.contains(event.target)) {
        onClose();
      }
    }

    if (settingsRef.current) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    loadLoginData();
  }, [accountData]);

  useEffect(() => {
    loadLoginData();
    if (settingState === "Account") changeItem(0);
    if (settingState === "Integrations") changeItem(1);
  }, []);

  const toggleDeleteAccountPopup = useCallback(() => {
    setIsDeletePopup((current) => !current);
  }, []);

  const tabs = [
    {
      tab: "Account",
      content: <Account onDelete={toggleDeleteAccountPopup} />,
    },
    {
      tab: "Preferences",
      content: <Preferences />,
    },
  ];

  const { currentIndex, currentItem, changeItem } = useTabs(0, tabs);

  return (
    <Flex
      h={"full"}
      width={isSmallScreen ? "640px" : "100%"}
      overflowX={isSmallScreen ? "hidden" : "visible"}
      position={isSmallScreen ? "absolute" : "fixed"}
      right={isSmallScreen ? "0" : "auto"}
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      zIndex={1001}
      ref={settingsRef}
      onClick={(e) => e.stopPropagation()}
    >
      <SettingsSidebar
        tabs={tabs}
        currentIndex={currentIndex}
        changeItem={changeItem}
      />
      <SettingsContent
        onClose={onClose}
        currentContent={currentItem.content}
      >
        {currentItem.content}
      </SettingsContent>
      {isDeletePopup ? (
        <DeletePopup
          toggleDeletePopup={toggleDeleteAccountPopup}
          loginData={loginData}
        />
      ) : null}
    </Flex>
  );
}
